<mat-tree
	#tree
	[dataSource]="selectableLocations()"
	[childrenAccessor]="locationChildrenAccessor"
>
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
		@if (node.name && node.name.length > 0) {
			<button mat-icon-button disabled></button>
			<mat-checkbox
				[checked]="locationChecklistSelection.isSelected(node)"
				(change)="locationChecklistSelection.toggle(node)"
				>{{ node.name }}</mat-checkbox
			>
		}
	</mat-tree-node>

	<mat-tree-node
		*matTreeNodeDef="let node; when: locationHasChild"
		matTreeNodePadding
		[cdkTreeNodeTypeaheadLabel]="node.name"
	>
		@if (node.name) {
			<button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
				<mat-icon>
					{{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
				</mat-icon>
			</button>
			<mat-checkbox
				[checked]="descendantsAllSelected(node)"
				[indeterminate]="descendantsPartiallySelected(node)"
				(change)="locationItemSelectionToggle(node)"
				>{{ node.name }}</mat-checkbox
			>
		}
	</mat-tree-node>
</mat-tree>
